import EditorjsList from "@editorjs/list"

const INLINE_RICH_TEXT_SANITIZE = {
  b: true,
  strong: true,
  i: true,
  em: true,
  u: true,
  code: true,
  mark: true,
  br: true,
  div: true,
  a: {
    href: true,
    target: true,
    rel: true
  },
  span: {
    class: true,
    style: true
  },
  font: {
    color: true
  }
}

function nestedListItemSanitize(depth = 0) {
  if (depth >= 32) {
    return {
      content: INLINE_RICH_TEXT_SANITIZE,
      meta: true
    }
  }

  return {
    content: INLINE_RICH_TEXT_SANITIZE,
    meta: true,
    items: nestedListItemSanitize(depth + 1)
  }
}

function normalizeSoftBreaks(items) {
  if (!Array.isArray(items)) return

  items.forEach((item) => {
    if (item && typeof item.content === "string") {
      item.content = item.content.replace(/\r?\n/g, "<br>")
    }

    normalizeSoftBreaks(item?.items)
  })
}

export default class ListTool extends EditorjsList {
  static get sanitize() {
    return {
      style: true,
      meta: true,
      items: nestedListItemSanitize()
    }
  }

  save() {
    const data = super.save()
    normalizeSoftBreaks(data?.items)
    return data
  }
}
